import * as types from './types'
import {
  CreateOfflinePurchaseLineRequest,
  CreateWorkorderActionRequest,
  CreateWorkorderLineRequest,
  DELETEWorkorderResponse,
  GETArrayResponse,
  GETBandenNuURLResponse,
  GETOrderAccountsResponse,
  GETPreInvoiceCheckResponse,
  GETVehicleProductHistoryReponse,
  GETWholesalerIframeURL,
  GETWorkorderAction,
  GETWorkorderAppointment,
  GETWorkorderImagesResponse,
  GETWorkorderItemSearch,
  GETWorkorderLinesResponse,
  GETWorkorderResponse,
  GETWorkorderSignalsResponse,
  GETWorkorderWithRelatedResponse,
  GETWorkordersResponse,
  GetAvailabilityDateResponse,
  GetWorkorderLineResponse,
  IAppointment,
  IDefaultDeleteResponse,
  IDefaultInvoiceTypeRequest,
  IEmailProposalRequest,
  IParamsData,
  IPostSupplierOrderData,
  ISubmitInvoiceRequest,
  IWorkorder,
  IWorkorderAction,
  IWorkorderPortalDashboard,
  POSTInvoiceResponse,
  POSTSupplierOrderParamsResponse,
  POSTSupplierOrderResponse,
  POSTWorkorderLineResponse,
  POSTWorkorderResponse,
  PUTLinkVehicleToRequest,
  PUTLinkVehicleToWorkorder,
  PUTUnlinkVehicleToWorkorder,
  PUTWholesalerIframeCartToWorkorder,
  PaginatedResponse,
  PostMultipleLines,
  UUIDResponse,
  UpdateWorkorderLineRequest
} from '@cbgms/api'
import * as requests from '@cbgms/api/modules/workorder/requests'
import { UserType, WorkorderLineStatus } from '@cbgms/api/modules/enums'
import { IPaginatedRequest } from '@cbgms/api/request'
import { listChecklists } from '@cbgms/api/modules/checklists/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { IChecklistsResult } from '@cbgms/api/modules/checklists'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const getWorkorders = (params: IPaginatedRequest = {}) =>
  AsyncAction<GETWorkordersResponse>({
    type: [types.LOAD_WORKORDERS, types.LOAD_WORKORDERS_SUCCESS, types.LOAD_WORKORDERS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorders(params)
    }
  })

export const createWorkorder = (data?: Partial<IWorkorder>) =>
  AsyncAction<POSTWorkorderResponse>({
    type: [types.CREATE_WORKORDER, types.CREATE_WORKORDER_SUCCESS, types.CREATE_WORKORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.createWorkorder(data)
    }
  })

export const deleteWorkorder = (UUID: string, dryRun?: boolean, reason?: string) =>
  AsyncAction<DELETEWorkorderResponse>({
    type: [types.DELETE_WORKORDER, types.DELETE_WORKORDER_SUCCESS, types.DELETE_WORKORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.deleteWorkorder(UUID, dryRun, reason)
    }
  })

export const getWorkorder = (UUID: string, ignoreError?: boolean) =>
  AsyncAction<GETWorkorderResponse>({
    type: [types.LOAD_WORKORDER, types.LOAD_WORKORDER_SUCCESS, types.LOAD_WORKORDER_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/workorders/${UUID}`
      }
    },
    shouldIgnoreError: ignoreError
  })

export const updateWorkorder = (workorderUUID: string, data: Partial<IWorkorder>) => ({
  type: [types.UPDATE_WORKORDER, types.UPDATE_WORKORDER_SUCCESS, types.UPDATE_WORKORDER_FAILED],
  payload: {
    api: 'gms',
    request: requests.updateWorkorder(workorderUUID, data)
  }
})

export const linkVehicleToWorkorder = (workorderUUID: string, data: PUTLinkVehicleToRequest) =>
  AsyncAction<PUTLinkVehicleToWorkorder>({
    type: [types.LINK_VEHICLE_FROM_WORKORDER, types.LINK_VEHICLE_FROM_WORKORDER_SUCCESS, types.LINK_VEHICLE_FROM_WORKORDER_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/link-vehicle`,
        data
      }
    }
  })

export const unlinkVehicleFromWorkorder = (workorderUUID: string) =>
  AsyncAction<PUTUnlinkVehicleToWorkorder>({
    type: [types.UNLINK_VEHICLE_FROM_WORKORDER, types.UNLINK_VEHICLE_FROM_WORKORDER_SUCCESS, types.UNLINK_VEHICLE_FROM_WORKORDER_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/unlink-vehicle`
      }
    }
  })

export const getVehicleProductHistory = (
  vehicleUUID: string,
  orderAccountUUID: string,
  excludeAvailability = false,
  searchTerm?: string,
  cursor?: string
) =>
  AsyncAction<GETVehicleProductHistoryReponse>({
    type: [types.GET_VEHICLE_PRODUCT_HISTORY, types.GET_VEHICLE_PRODUCT_HISTORY_SUCCESS, types.GET_VEHICLE_PRODUCT_HISTORY_FAILED],
    payload: {
      api: 'gms',
      request: requests.getVehicleProductHistory(vehicleUUID, orderAccountUUID, excludeAvailability, searchTerm, cursor)
    }
  })

export const AddOfflineWorkorderLines = (workorderUUID: string, data: CreateOfflinePurchaseLineRequest) =>
  AsyncAction<POSTWorkorderLineResponse>({
    type: [types.ADD_OFFLINE_WORKORDER_LINES, types.ADD_OFFLINE_WORKORDER_LINES_SUCCESS, types.ADD_OFFLINE_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: `/modules/workorders/${workorderUUID}/lines/offline-purchases`,
        data
      }
    }
  })

export const addWorkorderLine = (workorderUUID: string, data: CreateWorkorderLineRequest) =>
  AsyncAction<POSTWorkorderLineResponse>({
    type: [types.ADD_PRODUCT, types.ADD_PRODUCT_SUCCESS, types.ADD_PRODUCT_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: `/modules/workorders/${workorderUUID}/lines`,
        data
      }
    }
  })

export const duplicateWorkorderLine = (workorderUUID: string, lineUUID: string) =>
  AsyncAction<POSTWorkorderLineResponse>({
    type: [types.DUPLICATE_PRODUCT, types.DUPLICATE_PRODUCT_SUCCESS, types.DUPLICATE_PRODUCT_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}/duplicate`
      }
    }
  })

export const getWorkorderLines = (workorderUUID: string) =>
  AsyncAction<GETWorkorderLinesResponse>({
    type: [types.GET_WORKORDER_LINES, types.GET_WORKORDER_LINES_SUCCESS, types.GET_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderLines(workorderUUID)
    }
  })

// result not stored in redux store
export const getWorkorderLinesStateless = (workorderUUID: string) =>
  createAsyncApiAction<GETWorkorderLinesResponse>('gms', requests.getWorkorderLines(workorderUUID))

export const deleteLine = (workorderUUID: string, lineUUID: string) =>
  AsyncAction<GETWorkorderLinesResponse>({
    type: [types.DELETE_WORKORDER_LINES, types.DELETE_WORKORDER_LINES_SUCCESS, types.DELETE_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}`
      }
    }
  })

export const deleteMultipleLine = (workorderUUID: string, data: PostMultipleLines) =>
  AsyncAction<GETWorkorderLinesResponse>({
    type: [types.DELETE_WORKORDER_LINES, types.DELETE_WORKORDER_LINES_SUCCESS, types.DELETE_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: `/modules/workorders/${workorderUUID}/delete-lines`,
        data
      }
    }
  })

export const updateMultipleLine = (workorderUUID: string, newWorkorderUUID: string, data: PostMultipleLines) =>
  AsyncAction<GETWorkorderLinesResponse>({
    type: [types.UPDATE_WORKORDER_LINES, types.UPDATE_WORKORDER_LINES_SUCCESS, types.UPDATE_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/update-lines/${newWorkorderUUID}`,
        data
      }
    }
  })

export const getLine = (workorderUUID: string, lineUUID: string) =>
  AsyncAction<GetWorkorderLineResponse>({
    type: [types.GET_WORKORDER_LINE, types.GET_WORKORDER_LINE_SUCCESS, types.GET_WORKORDER_LINE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}`
      }
    }
  })

export const updateParentLinesSortOrder = (workorderUUID: string, LineUUIDS: string[]) => ({
  type: [types.UPDATE_WORKORDER_LINES_SORT, types.UPDATE_WORKORDER_LINES_SORT_SUCCESS, types.UPDATE_WORKORDER_LINES_SORT_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/workorders/${workorderUUID}/lines/sort-order`,
      data: {
        LineUUIDS
      }
    }
  }
})

export const updateChildLinesSortOrder = (workorderUUID: string, LineUUIDS: string[], ParentUUID: string) => ({
  type: [
    types.UPDATE_WORKORDER_CHILD_LINES_SORT,
    types.UPDATE_WORKORDER_CHILD_LINES_SORT_SUCCESS,
    types.UPDATE_WORKORDER_CHILD_LINES_SORT_FAILED
  ],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/workorders/${workorderUUID}/lines/${ParentUUID}/sort-order`,
      data: {
        LineUUIDS
      }
    }
  }
})

export const updateChildToParentLine = (workorderUUID: string, lineUUID: string, LineUUIDS: string[]) => ({
  type: [types.UPDATE_WORKORDER_CHILD_PARENT, types.UPDATE_WORKORDER_CHILD_PARENT_SUCCESS, types.UPDATE_WORKORDER_CHILD_PARENT_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}/update-child-to-parent`,
      data: {
        LineUUIDS
      }
    }
  }
})

export const updateParentToChildLine = (workorderUUID: string, lineUUID: string, parentLineUUID: string, LineUUIDS: string[]) => ({
  type: [types.UPDATE_WORKORDER_PARENT_CHILD, types.UPDATE_WORKORDER_PARENT_CHILD_SUCCESS, types.UPDATE_WORKORDER_PARENT_CHILD_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}/${parentLineUUID}/update-parent-to-child`,
      data: {
        LineUUIDS
      }
    }
  }
})

export const updateLine = (workorderUUID: string, lineUUID: string, data: UpdateWorkorderLineRequest) =>
  AsyncAction<GETWorkorderLinesResponse>({
    type: [types.UPDATE_WORKORDER_LINES, types.UPDATE_WORKORDER_LINES_SUCCESS, types.UPDATE_WORKORDER_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}`,
        data
      }
    }
  })

export const getOrderAccounts = (params: IPaginatedRequest) =>
  AsyncAction<GETOrderAccountsResponse>({
    type: [types.GET_ORDER_ACCOUNTS, types.GET_ORDER_ACCOUNTS_SUCCESS, types.GET_ORDER_ACCOUNTS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/wholesaler/order-account',
        params
      }
    }
  })

export const resetOrderAccounts = () => ({
  type: types.RESET_ORDER_ACCOUNTS
})

export const getBandenNuTyresURL = (orderAccountUUID: string) =>
  createAsyncApiAction<GETBandenNuURLResponse>('gms', {
    method: 'GET',
    url: `/modules/wholesaler/order-account/${orderAccountUUID}/bandennu-tyres-url`
  })

export const getCustomerContactInfo = (orderAccountUUID: string) => ({
  type: [types.GET_CUSTOMER_CONTACT_INFO, types.GET_CUSTOMER_CONTACT_INFO_SUCCESS, types.GET_CUSTOMER_CONTACT_INFO_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/wholesaler/order-account/${orderAccountUUID}/contact-info-customer`
    }
  }
})

export const getSupplierContactInfo = (orderAccountUUID: string) => ({
  type: [types.GET_SUPPLIER_CONTACT_INFO, types.GET_SUPPLIER_CONTACT_INFO_SUCCESS, types.GET_SUPPLIER_CONTACT_INFO_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/wholesaler/order-account/${orderAccountUUID}/contact-info-supplier`
    }
  }
})

export const getSupplierOrderParts = (workorderUUID: string) => ({
  type: [types.GET_SUPPLIER_ORDER_PARTS, types.GET_SUPPLIER_ORDER_PARTS_SUCCESS, types.GET_SUPPLIER_ORDER_PARTS_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/workorders/${workorderUUID}/supplier-order-parts`
    }
  }
})

export const incrementSupplierOrderPart = (supplierOrderPartsUUID: string) => ({
  type: types.INCREMENT_SUPPLIER_ORDER_PART,
  payload: {
    supplierOrderPartsUUID
  }
})

export const decrementSupplierOrderPart = (supplierOrderPartsUUID: string) => ({
  type: types.DECREMENT_SUPPLIER_ORDER_PART,
  payload: {
    supplierOrderPartsUUID
  }
})

export const resetSupplierOrderPart = () => ({
  type: types.RESET_SUPPLIER_ORDER_PART
})

export const getSupplierOrderParams = (workorderUUID: string, data: IParamsData) =>
  AsyncAction<POSTSupplierOrderParamsResponse>({
    type: [types.GET_SUPPLIER_ORDER_PARAMS, types.GET_SUPPLIER_ORDER_PARAMS_SUCCESS, types.GET_SUPPLIER_ORDER_PARAMS_FAILED],
    payload: {
      api: 'gms',
      orderAccountUUID: data.OrderAccountUUID,
      request: requests.postSupplierOrderParams(workorderUUID, data)
    }
  })

export const updateLineItemsAvailability = (workorderUUID: string, data: IParamsData) => ({
  type: [types.PUT_LINE_AVAILABILITY, types.PUT_LINE_AVAILABILITY_SUCCESS, types.PUT_LINE_AVAILABILITY_FAILED],
  payload: {
    api: 'gms',
    orderAccountUUID: data.OrderAccountUUID,
    request: requests.putLinesAvailibilityRefresh(workorderUUID, data)
  }
})

export const getOrderDeliveryTimes = (orderAccountUUID: string) => ({
  type: [types.GET_ORDER_DELIVERY_TIMES, types.GET_ORDER_DELIVERY_TIMES_SUCCESS, types.GET_ORDER_DELIVERY_TIMES_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/wholesaler/order-account/${orderAccountUUID}/delivery-times`
    }
  }
})

export const getOrderPickupTimes = (orderAccountUUID: string) => ({
  type: [types.GET_ORDER_PICKUP_TIMES, types.GET_ORDER_PICKUP_TIMES_SUCCESS, types.GET_ORDER_PICKUP_TIMES_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/wholesaler/order-account/${orderAccountUUID}/pickup-times`
    }
  }
})

export const createInvoice = (workorderUUID: string, data: object) =>
  AsyncAction<POSTInvoiceResponse>({
    type: [types.CREATE_INVOICE, types.CREATE_INVOICE_SUCCESS, types.CREATE_INVOICE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: `/modules/workorders/${workorderUUID}/invoice`,
        data
      }
    }
  })

export const preInvoiceCheck = (workorderUUID: string) =>
  AsyncAction<GETPreInvoiceCheckResponse>({
    type: [types.PRE_INVOICE_CHECK, types.PRE_INVOICE_CHECK_SUCCESS, types.PRE_INVOICE_CHECK_FAILED],
    payload: {
      api: 'gms',
      request: requests.getPreInvoiceCheck(workorderUUID)
    }
  })

export const movePortalOrderToArchive = (workorderUUID: string, data?: ISubmitInvoiceRequest) => ({
  type: [types.ARCHIVE_WORKORDER, types.ARCHIVE_WORKORDER_SUCCESS, types.ARCHIVE_WORKORDER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'POST',
      url: `/modules/workorders/${workorderUUID}/portal-archived-order`,
      data
    }
  }
})

export const emailApproval = (workorderUUID: string, data: IEmailProposalRequest) => {
  return AsyncAction<UUIDResponse>({
    type: [types.EMAIL_APPROVAL, types.EMAIL_APPROVAL_SUCCESS, types.EMAIL_APPROVAL_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/email-approval`,
        data
      }
    }
  })
}

export const notifyMyKar = (workorderUUID: string) => ({
  type: [types.NOTIFY_MYKAR, types.NOTIFY_MYKAR_SUCCESS, types.NOTIFY_MYKAR_FAILED],
  payload: {
    api: 'gms',
    request: requests.notifyMyKar(workorderUUID)
  }
})

export const getFirstAppointment = (workorderUUID: string) =>
  AsyncAction<GETWorkorderAppointment>({
    type: [types.GET_FIRST_APPOINTMENT, types.GET_FIRST_APPOINTMENT_SUCCESS, types.GET_FIRST_APPOINTMENT_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/workorder-appointments/workorder/${workorderUUID}/first`
      }
    }
  })

export const getFirstAppointmentStateless = (workorderUUID: string) =>
  createAsyncApiAction<GETWorkorderAppointment>('gms', {
    method: 'GET',
    url: `/modules/workorder-appointments/workorder/${workorderUUID}/first`
  })

export const loadWorkordersByVehicle = (params: IPaginatedRequest) =>
  AsyncAction<GETWorkordersResponse>({
    type: [types.LOAD_VEHICLE_WORKORDERS, types.LOAD_VEHICLE_WORKORDERS_SUCCESS, types.LOAD_VEHICLE_WORKORDERS_FAILED],
    payload: {
      api: 'gms',
      request: requests.loadWorkordersByVehicle(params)
    }
  })

export const loadWorkordersByAccount = (params: IPaginatedRequest) =>
  AsyncAction<GETWorkordersResponse>({
    type: [types.LOAD_ACCOUNT_WORKORDERS, types.LOAD_ACCOUNT_WORKORDERS_SUCCESS, types.LOAD_ACCOUNT_WORKORDERS_FAILED],
    payload: {
      api: 'gms',
      request: requests.loadWorkordersByAccount(params)
    }
  })

export const sendSmsMessage = (MessageBody: string, MobileNumber: string, AccountUUID?: string) => ({
  type: [types.SEND_SMS_MESSAGE, types.SEND_SMS_MESSAGE_SUCCESS, types.SEND_SMS_MESSAGE_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'POST',
      url: '/modules/sms/message',
      data: {
        MessageBody,
        AccountUUID,
        MobileNumber
      }
    }
  }
})

export const getAdditionalWork = (workorderUUID: string, vehicleUUID: string) =>
  AsyncAction<{}>({
    type: [types.GET_REPAIR_TIMES, types.GET_REPAIR_TIMES_SUCCESS, types.GET_REPAIR_TIMES_FAILED],
    payload: {
      api: 'gms',
      vehicleUUID,
      request: {
        method: 'GET',
        url: `/modules/workorders/${workorderUUID}/haynespro/maintenance-tasks`
      }
    }
  })

export const deleteOrderPartLine = (uuid: string, deliveryTime: string) => ({
  type: types.DELETE_ORDERPARTLINE_LOCAL,
  payload: { lineUUID: uuid, deliveryTime }
})

export const deleteOrderPartLineApi = (workorderUUID: string, lineUUID: string, deliveryTime: string) =>
  AsyncAction({
    type: [types.DELETE_ORDERPARTLINE, types.DELETE_ORDERPARTLINE_SUCCESS, types.DELETE_ORDERPARTLINE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/workorders/${workorderUUID}/lines/${lineUUID}`
      },
      lineUUID,
      deliveryTime
    },
    // errors are handled by the caller (PartsTable), ErrWorkorderLineNotFound is not an error there
    shouldIgnoreError: true
  })

export const deleteOrderPartLineLocal = (lineUUID: string, deliveryTime: string) => ({
  type: types.DELETE_ORDERPARTLINE_LOCAL,
  payload: { lineUUID, deliveryTime }
})

export const placeOrder = (workorderUUID: string, data: IPostSupplierOrderData) =>
  AsyncAction<POSTSupplierOrderResponse>({
    type: [types.PLACE_ORDER, types.PLACE_ORDER_SUCCESS, types.PLACE_ORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.postSupplierOrder(workorderUUID, data)
    }
  })

export const placeOrderQuickly = (workorderUUID: string) =>
  AsyncAction<POSTSupplierOrderResponse>({
    type: [types.PLACE_ORDER, types.PLACE_ORDER_SUCCESS, types.PLACE_ORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.postSupplierOrderQuickly(workorderUUID)
    }
  })

export const getSundry = () => ({
  type: [types.GET_SUNDRY, types.GET_SUNDRY_SUCCESS, types.GET_SUNDRY_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: '/modules/workorders/sundries/default'
    }
  }
})

export const itemSearch = (query: string, limit = 100) =>
  AsyncAction<GETWorkorderItemSearch>({
    type: [types.ITEM_SEARCH, types.ITEM_SEARCH_SUCCESS, types.ITEM_SEARCH_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/workorders/items/search',
        params: {
          limit,
          query
        }
      }
    }
  })

export interface IGetRecentlyModifiedWorkorderLines {
  modifiedByType?: UserType
  modifiedByUUID?: string
  resultLimit?: number
  onlyParentLines?: boolean
}

interface IGetRecentlyModifiedWorkorderLinesRequestParams {
  ModifiedByType?: UserType
  ModifiedByUuid?: string
  ResultLimit: number | undefined
  OnlyShowParentLines?: boolean
}

export const getRecentlyModifiedWorkorderLines = (params: IGetRecentlyModifiedWorkorderLines) => {
  const paramsToSend: IGetRecentlyModifiedWorkorderLinesRequestParams = {
    ResultLimit: params.resultLimit
  }

  if (params.modifiedByUUID) {
    paramsToSend.ModifiedByUuid = params.modifiedByUUID
  }
  if (params.modifiedByType) {
    paramsToSend.ModifiedByType = params.modifiedByType
  }
  if (params.onlyParentLines) {
    paramsToSend.OnlyShowParentLines = params.onlyParentLines
  }

  return {
    type: [types.LOAD_CHANGED_LINES, types.LOAD_CHANGED_LINES_SUCCESS, types.LOAD_CHANGED_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/dashboard/recently-modified-workorder-lines',
        params: paramsToSend
      }
    }
  }
}

export const clearWorkorder = () => ({
  type: types.CLEAR_WORKORDER
})

export const getWorkorderWithRelated = (workorderUUID: string) =>
  AsyncAction<GETWorkorderWithRelatedResponse>({
    type: [types.GET_WORKORDER_WITH_RELATED, types.GET_WORKORDER_WITH_RELATED_SUCCESS, types.GET_WORKORDER_WITH_RELATED_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderWithRelated(workorderUUID)
    }
  })

export const getWorkorderWithRelatedPublic = (token: string) => ({
  type: [
    types.GET_WORKORDER_WITH_RELATED_PUBLIC,
    types.GET_WORKORDER_WITH_RELATED_PUBLIC_SUCCESS,
    types.GET_WORKORDER_WITH_RELATED_PUBLIC_FAILED
  ],
  payload: {
    api: 'gms',
    request: requests.getWorkorderWithRelatedPublic(token)
  }
})

export const getAppointmentAvailability = (token: string) => ({
  type: [types.GET_APPOINTMENT_AVAILABILITY, types.GET_APPOINTMENT_AVAILABILITY_SUCCESS, types.GET_APPOINTMENT_AVAILABILITY_FAILED],
  payload: {
    api: 'gms',
    request: requests.getAppointmentAvailability(token)
  }
})

export const getWorkorderAppointmentAvailability = (workorderUUID: string) =>
  AsyncAction<GetAvailabilityDateResponse>({
    type: [types.GET_APPOINTMENT_AVAILABILITY, types.GET_APPOINTMENT_AVAILABILITY_SUCCESS, types.GET_APPOINTMENT_AVAILABILITY_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderAppointmentAvailability(workorderUUID)
    }
  })

export const createAppointmentProposal = (token: string, data: Partial<IAppointment>) => ({
  type: [types.CREATE_APPOINTMENT_PROPOSAL, types.CREATE_APPOINTMENT_PROPOSAL_SUCCESS, types.CREATE_APPOINTMENT_PROPOSAL_FAILED],
  payload: {
    api: 'gms',
    request: requests.createAppointmentProposal(token, data)
  }
})

export const putWorkorderLineApprovalPublic = (token: string, lines: string[], status: WorkorderLineStatus) => ({
  type: [
    types.PUT_WORKORDER_LINE_APPROVAL_PUBLIC,
    types.PUT_WORKORDER_LINE_APPROVAL_PUBLIC_SUCCESS,
    types.PUT_WORKORDER_LINE_APPROVAL_PUBLIC_FAILED
  ],
  payload: {
    api: 'gms',
    request: requests.putWorkorderLineApprovalPublic(token, lines, status)
  }
})

export const restoreWorkorderFromInvoice = (invoiceUUID: string) => ({
  type: [types.RESTORE_WORKORDER_FROM_INVOICE, types.RESTORE_WORKORDER_FROM_INVOICE_SUCCESS, types.RESTORE_WORKORDER_FROM_INVOICE_FAILED],
  payload: {
    api: 'gms',
    request: requests.restoreWorkorderFromInvoice(invoiceUUID)
  }
})

export const restoreWorkorderFromQuotation = (quotationUUID: string) =>
  AsyncAction<UUIDResponse>({
    type: [
      types.RESTORE_WORKORDER_FROM_QUOTATION,
      types.RESTORE_WORKORDER_FROM_QUOTATION_SUCCESS,
      types.RESTORE_WORKORDER_FROM_QUOTATION_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.restoreWorkorderFromQuotation(quotationUUID)
    }
  })

export const clearWorkorderChecklists = () => ({
  type: types.CLEAR_WORKORDER_CHECKLISTS
})

export const getWorkorderChecklists = (workorderUUID: string) =>
  AsyncAction<PaginatedResponse<IChecklistsResult>>({
    type: [types.GET_WORKORDER_CHECKLISTS, types.GET_WORKORDER_CHECKLISTS_SUCCESS, types.GET_WORKORDER_CHECKLISTS_FAILED],
    payload: {
      api: 'gms',
      request: listChecklists({
        fields: '*',
        search: `Checklist.WorkorderUUID|=|${workorderUUID}`
      })
    }
  })

export const searchQuickCreate = (query: string) => ({
  type: [types.GET_SEARCH_QUICK_CREATE, types.GET_SEARCH_QUICK_CREATE_SUCCESS, types.GET_SEARCH_QUICK_CREATE_FAILED],
  payload: {
    api: 'gms',
    request: requests.searchQuickCreate(query)
  }
})

export const getWorkorderSignals = (workorderUUID: string) =>
  AsyncAction<GETWorkorderSignalsResponse>({
    type: [types.GET_WORKORDER_WARNINGS, types.GET_WORKORDER_WARNINGS_SUCCESS, types.GET_WORKORDER_WARNINGS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderSignals(workorderUUID)
    }
  })

export const getWorkorderImages = (workorderUUID: string) =>
  AsyncAction<GETWorkorderImagesResponse>({
    type: [types.GET_WORKORDER_IMAGES, types.GET_WORKORDER_IMAGES_SUCCESS, types.GET_WORKORDER_IMAGES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderImages(workorderUUID)
    }
  })

export const getWorkordersPortalDashboard = () =>
  createAsyncApiAction<GETArrayResponse<IWorkorderPortalDashboard>>('gms', requests.getWorkordersPortalDashboard())

export const getWorkordersAssignedToEmployee = (predefinedSearch: IPaginatedRequest, shopID?: string) =>
  AsyncAction<GETWorkordersResponse>({
    type: [
      types.GET_WORKORDERS_ASSIGNED_TO_EMPLOYEE,
      types.GET_WORKORDERS_ASSIGNED_TO_EMPLOYEE_SUCCESS,
      types.GET_WORKORDERS_ASSIGNED_TO_EMPLOYEE_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.getWorkordersAssignedToEmployee(predefinedSearch, shopID)
    }
  })

export const getWholesalerIframeURL = (workorderUUID: string, workorderLineUUID: string, orderAccountUUID: string, vehicleUUID?: string) =>
  AsyncAction<GETWholesalerIframeURL>({
    type: [types.GET_WHOLESALER_IFRAME_URL, types.GET_WHOLESALER_IFRAME_URL_SUCCESS, types.GET_WHOLESALER_IFRAME_URL_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWholesalerIframeURL(workorderUUID, workorderLineUUID, orderAccountUUID),
      vehicleUUID // for vehicle enrichment
    }
  })

export const wholeSalerIframeCartToWorkorder = (
  workorderUUID: string,
  workorderLineUUID: string,
  orderAccountUUID: string,
  sessionID: string
) =>
  AsyncAction<PUTWholesalerIframeCartToWorkorder>({
    type: [
      types.PUT_WHOLESALER_IFRAME_CART_TO_WORKORDER,
      types.PUT_WHOLESALER_IFRAME_CART_TO_WORKORDER_SUCCESS,
      types.PUT_WHOLESALER_IFRAME_CART_TO_WORKORDER_FAILED
    ],
    payload: {
      api: 'gms',
      request: requests.wholeSalerIframeCartToWorkorder(workorderUUID, workorderLineUUID, orderAccountUUID, sessionID)
    }
  })

export const processExternalOrder = (workorderUUID: string, workorderLineUUID: string, orderAccountUUID: string, sessionID: string) =>
  AsyncAction<PUTWholesalerIframeCartToWorkorder>({
    type: [types.PROCESS_EXTERNAL_ORDER, types.PROCESS_EXTERNAL_ORDER_SUCCESS, types.PROCESS_EXTERNAL_ORDER_FAILED],
    payload: {
      api: 'gms',
      request: requests.processExternalOrder(workorderUUID, workorderLineUUID, orderAccountUUID, sessionID)
    }
  })

export const deleteWorkorderLines = (workorderUUID: string) =>
  AsyncAction<IDefaultDeleteResponse>({
    type: [types.DELETE_WORKORDER_ALL_LINES, types.DELETE_WORKORDER_ALL_LINES_SUCCESS, types.DELETE_WORKORDER_ALL_LINES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/workorders/${workorderUUID}/lines`
      }
    }
  })

export const updateDefaultInvoiceType = (workorderUUID: string, data: IDefaultInvoiceTypeRequest) =>
  AsyncAction<UUIDResponse>({
    type: [types.PUT_DEFAULT_INVOICE_TYPE, types.PUT_DEFAULT_INVOICE_TYPE_SUCCESS, types.PUT_DEFAULT_INVOICE_TYPE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/default-invoice-type`,
        data
      }
    }
  })

export const getWorkorderAction = (workorderUUID: string) =>
  AsyncAction<GETWorkorderAction>({
    type: [types.GET_ACTION, types.GET_ACTION_SUCCESS, types.GET_ACTION_FAILED],
    payload: {
      api: 'gms',
      request: requests.getWorkorderAction(workorderUUID)
    }
  })

export const addWorkorderAction = (workorderUUID: string, data: CreateWorkorderActionRequest) =>
  AsyncAction<UUIDResponse>({
    type: [types.ADD_ACTION, types.ADD_ACTION_SUCCESS, types.ADD_ACTION_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: `/modules/workorders/${workorderUUID}/actions`,
        data
      }
    }
  })

export const updateWorkorderAction = (workorderUUID: string, actionUUID: string, data: CreateWorkorderActionRequest) =>
  AsyncAction<UUIDResponse>({
    type: [types.PUT_ACTION_TYPE, types.PUT_ACTION_TYPE_SUCCESS, types.PUT_ACTION_TYPE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorders/${workorderUUID}/actions/${actionUUID}`,
        data
      }
    }
  })

export const deleteWorkorderAction = (workorderUUID: string, actionUUID: string) =>
  AsyncAction<UUIDResponse>({
    type: [types.DELETE_ACTION, types.DELETE_ACTION_SUCCESS, types.DELETE_ACTION_FAILED],
    payload: {
      api: 'gms',
      request: requests.deleteWorkorderAction(workorderUUID, actionUUID)
    }
  })

export const setAmountLimit = (payload: IWorkorderAction | null) => ({
  type: types.SET_AMOUNT_LIMIT,
  payload
})

export const getPastInvoicesParts = (vehicleUUID?: string) => ({
  type: [types.DELETE_ACTION, types.DELETE_ACTION_SUCCESS, types.DELETE_ACTION_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/workorder-invoices/past-invoiced-parts/${vehicleUUID}`
    }
  },
  Data: []
})
